module.exports = __webpack_public_path__ + "img/btn_添加.fc9eb454.svg";